import React from "react";
import { useSelector } from "react-redux";
import VideoTitle from "./VideoTitle";
import VideoBackground from "./VideoBackground";
import { RootState } from "../../store";

const MainContainer = () => {
  const movies = useSelector((store: RootState) => store.movies?.trendingMovies);

  if (!movies) return null;

  // We can pick any movie from the list. Here we pick one based on a predictable index or random.
  const mainMovie = movies[0];

  if (!mainMovie) return null;

  const { original_title, overview, id } = mainMovie;

  return (
    <div className="relative w-full h-screen overflow-hidden">
      <VideoBackground movieId={id} />
      <div className="absolute inset-0 bg-gradient-to-r from-black via-black/20 to-transparent">
        <VideoTitle title={original_title} overview={overview} />
      </div>
    </div>
  );
};

export default MainContainer;
